export default "__VITE_ASSET__BEz69Ktw__"